import React from 'react';

const IwocaPayBackdrop = (props) => {
  return (
    <svg
      width="230"
      height="210"
      viewBox="0 0 230 210"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <g clipPath="url(#clip0_2206_1499)">
        <path
          d="M177.067 76.2172C183.153 50.8804 167.555 25.3928 142.218 19.3069C116.881 13.2211 91.3932 28.8191 85.3074 54.1559C79.2215 79.4928 94.8195 104.98 120.156 111.066C145.493 117.152 170.981 101.554 177.067 76.2172ZM109.691 60.0274C112.529 48.1437 124.491 40.8477 136.375 43.6847C148.259 46.5218 155.555 58.4847 152.718 70.3683C149.881 82.2519 137.918 89.5481 126.034 86.711C114.144 83.8451 106.826 71.9173 109.691 60.0274Z"
          fill="#D4E3F7"
        />
        <path
          d="M209 250.5L230.5 217C229.487 212.377 178.108 213.74 146.5 203.5C80.5031 182.119 18.0903 162.176 3.92821 97.5275C2.98776 93.2821 2.067 89.0151 1.04605 84.3457C0.441365 81.5801 0.283543 79.5604 -1.76635 78.1419C-3.81624 76.7234 -6.39611 76.2229 -8.89521 76.768L-157.879 109.185C-162.528 110.195 -165.592 114.52 -164.872 119.021C-164.061 123.944 -163.125 128.867 -162.073 133.658C-135.421 255.329 -30.2607 340.952 91.9741 352.896C105.502 354.775 120.005 355.187 135.579 353.998C145.658 353.528 153.596 352.405 153.596 352.405C153.596 352.405 165.702 350.042 167.949 349.552C168.398 349.454 169.701 349.151 171.895 348.689C176.907 347.635 181.997 346.427 187.036 345.109C191.634 343.886 194.509 339.444 193.565 334.987L177.5 258L209 250.5Z"
          fill="#FB5950"
        />
        <g opacity="0.25" filter="url(#filter0_f_2206_1499)">
          <ellipse
            cx="32.5215"
            cy="151.789"
            rx="31.257"
            ry="6.65986"
            transform="rotate(37.2171 32.5215 151.789)"
            fill="url(#paint0_linear_2206_1499)"
          />
        </g>
        <circle
          cx="36.4699"
          cy="123.548"
          r="20.05"
          transform="rotate(41.6412 36.4699 123.548)"
          fill="#FFEFBF"
        />
        <circle
          cx="47.0128"
          cy="136.836"
          r="20.05"
          transform="rotate(41.6412 47.0128 136.836)"
          fill="#FFDF80"
        />
        <circle
          cx="58.6671"
          cy="148.874"
          r="20.05"
          transform="rotate(41.6412 58.6671 148.874)"
          fill="#FFBF00"
        />
        <path
          d="M68.1762 166.502C63.9885 166.955 64.7182 154.96 63.9951 148.276C63.272 141.592 63.3054 132.503 67.4932 132.05C70.9045 131.418 78.1176 138.858 78.5841 146.527C79.7329 155.218 74.9622 162.875 68.1762 166.502Z"
          fill="url(#paint1_radial_2206_1499)"
        />
        <path
          d="M46.4571 132.951C55.9313 126.833 60.0276 141.695 62.225 148.127C64.4224 154.56 64.1837 172.719 53.9053 167.857C50.7171 169.225 42.3468 162.774 39.8501 156.005C36.8732 146.599 39.5415 138.412 46.4571 132.951Z"
          fill="url(#paint2_radial_2206_1499)"
        />
        <path
          d="M220.827 196.048C214.417 189.326 203.769 189.067 197.047 195.477C190.325 201.887 190.067 212.536 196.477 219.258C202.886 225.98 213.535 226.238 220.257 219.828C226.979 213.418 227.237 202.77 220.827 196.048ZM202.95 213.092C199.94 209.944 200.069 204.951 203.217 201.941C206.364 198.931 211.357 199.06 214.367 202.208C217.377 205.355 217.248 210.348 214.101 213.358C210.943 216.364 205.956 216.249 202.95 213.092Z"
          fill="#DDE8EE"
        />
      </g>
      <defs>
        <filter
          id="filter0_f_2206_1499"
          x="5.6319"
          y="130.478"
          width="53.7792"
          height="42.6221"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="BackgroundImageFix"
            result="shape"
          />
          <feGaussianBlur
            stdDeviation="0.835417"
            result="effect1_foregroundBlur_2206_1499"
          />
        </filter>
        <linearGradient
          id="paint0_linear_2206_1499"
          x1="58.7326"
          y1="155.741"
          x2="-19.1057"
          y2="151.069"
          gradientUnits="userSpaceOnUse"
        >
          <stop />
          <stop offset="1" stopOpacity="0.3" />
        </linearGradient>
        <radialGradient
          id="paint1_radial_2206_1499"
          cx="0"
          cy="0"
          r="1"
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(80.0693 148.04) rotate(178.65) scale(15.1876 24.2403)"
        >
          <stop stopColor="white" stopOpacity="0.54" />
          <stop offset="1" stopColor="white" stopOpacity="0" />
        </radialGradient>
        <radialGradient
          id="paint2_radial_2206_1499"
          cx="0"
          cy="0"
          r="1"
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(40.4111 158.237) rotate(-2.47557) scale(14.0415 22.6614)"
        >
          <stop stopColor="#B38102" stopOpacity="0.25" />
          <stop offset="1" stopColor="#8B5C01" stopOpacity="0" />
        </radialGradient>
        <clipPath id="clip0_2206_1499">
          <rect width="230" height="210" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};

export default IwocaPayBackdrop;
